import { showApplyAccountPanel } from './apply-account';

export default function() {
    const form = document.getElementById('careers-form');
    if (!form) {
        return;
    }

    const validator = new ContactFormValidator({
        element: form
    });

    form.addEventListener('submit', async function(e) {
        e.preventDefault();
        if (!await validator.isValid()) {
            return false;
        }

        const signInPanel = document.querySelector('[data-apply-account-panel="sign-in"]');
        signInPanel?.querySelectorAll('.validation-error, .alert').forEach((error) => error.remove());

        const formData = new FormData(form);
        validator.preventInput();

        $.ajax({
            type: "POST",
            cache: false,
            processData: false,
            contentType: false,
            dataType: 'json',
            url: form.getAttribute('action'),
            data: formData,
            success: function(response) {
                validator.allowInput();

                if (response.success && response.success.already_applied) {
                    $('#careers-form').html('<div class="careers-thankyou"><h1>You have already applied for this job</h1><p>We already have your application for this role, so there\'s no need to apply again. A member of our team will be in touch with the next steps.</p></div>');
                    $('.careers-form')[0].scrollIntoView();
                    return;
                }

                var div = $('<div class="careers-thankyou"></div>');

                div.append('<h1>Thank you for your application</h1>');
                div.append('<p>We have received your application and a member of our team will be in touch shortly with the next steps.</p><img height=1 width=1 border=0 src="//conv.indeed.com/pagead/conv/3986726972655674/?script=0">');

                $('html, body').animate({
                    scrollTop: $('.careers-form').offset().top - 80
                }, 'slow');

                $('#careers-form').html(div);
                $('.careers-modal')[0].scrollIntoView();

                dataLayer.push({
                    'event' : 'trackEvent',
                    'eventCategory' : 'Careers - Apply For This Job',
                    'eventAction' : 'Form Complete',
                    'eventLabel' : 'Complete',
                    'eventValue' : 0,
                });
            },
            error: function(response) {
                if (response.status === 409) {
                    const signInEmail = document.getElementById('apply-sign-in-email');
                    if (signInEmail) {
                        signInEmail.value = form.querySelector('[name="email"]').value;
                    }
                    showApplyAccountPanel('sign-in');
                    validator.errorResponse(response);
                    signInPanel.prepend(form.querySelector('.validation-error'));
                    document.getElementById('apply-sign-in-password').focus();
                    return;
                }

                // $('.please-wait').hide();

                // $('html, body').animate({
                //     scrollTop: $('.careers-form').offset().top - 80
                // }, 'slow');
                validator.errorResponse(response);
                // outputErrorToForm('careers-form', parseErrorResponse(response));
            }
        });
    });
}